import { createStore, compose, applyMiddleware } from 'redux';
import createLogger from 'redux-logger';
import promise from 'redux-promise';
import thunk from 'redux-thunk';

import analyticsMiddleware from '../analytics-middleware';
import trackingEnhancer from '../../scripts/analytics/tracking-enhancer';
import reducer from './../reducers/index';
import storeInteractionConnect from '../../scripts/utilities/interaction-studio-actions-connect';

const createRedux = () => {
  const middlewares = [
    analyticsMiddleware,
    thunk,
    promise,
  ];

  if (process.env.ACTION_LOGGING) {
    middlewares.push(createLogger({
      collapsed: true,
      logErrors: process.env.ACTION_LOGGING,
    }));
  }

  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const enhancers = composeEnhancers(
    applyMiddleware(...middlewares),
    trackingEnhancer(),
  );

  const store = createStore(reducer, enhancers);

  if (Boolean(window)) {
    window.InteractionStudioStore = (data) => storeInteractionConnect(store, data);
  }

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      const nextRootReducer = require('../reducers/index');
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
};

export default createRedux();